import { render, staticRenderFns } from "./assessmentPreview.vue?vue&type=template&id=33d2dd71&scoped=true"
import script from "./assessmentPreview.vue?vue&type=script&lang=js"
export * from "./assessmentPreview.vue?vue&type=script&lang=js"
import style0 from "./assessmentPreview.vue?vue&type=style&index=0&id=33d2dd71&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d2dd71",
  null
  
)

export default component.exports